<template>
    <div
        data-dialog="true"
        id="printOrderDialog"
        class="flex flex-col relative w-[885px] print:w-full h-full bg-gray-tier-3"
    >
        <header class="sticky top-0 bg-gray-tier-2 border-b border-keyline-primary">
            <div class="w-full flex items-center justify-between py-2 px-6 print:px-0">

                <div class="flex items-center gap-4">
                    <h2>
                        {{ $t("Order #") }}
                        <span class="font-medium">{{ data }}</span>
                    </h2>

                    <span v-if="order && Object.keys(order).length > 0" class="font-medium text-secondary flex items-center">
                        <span 
                            v-if="order.record_type !== 'Q'" class="text-[.8rem] uppercase py-0.5 px-3 rounded-full inline-block"
                            :class="backgroundColorSourcing"
                        >
                            {{ order.status }}
                        </span>
                    </span>
                </div>

                <span class="print:hidden flex items-center justify-end gap-2">
                    <AppButton
                        @click="router.post(route('web.account.sales.orders.download', order.id))"
                        text="Download"
                        icon="export-file"
                        icon-size="large"
                        :disabled="inert"
                        :loading="inert"
                    />
                    <DialogCloseButton/>
                </span>
            </div>
        </header>
        <div 
            v-if="order && Object.keys(order).length > 0" 
            class="overflow-y-auto mt-[49px] relative"
            :class="scrollClasses"
            @scroll="handleScroll"
        >
            <RecordHeader :record="order" class="px-6 print:px-0 py-3 !fixed top-[51px] w-full type-secondary bg-gray-tier-2 border-b border-keyline-primary" />
            <OrderRecord v-bind="props" :fromDialog="true" :cards="cards" :fromSales="true" :salesData="salesData" class="p-6 print:px-0 mb-8" />
        </div>
        <div v-else-if="errors || (!order && !isLoading)" class="grow p-8 print:px-0 flex items-center justify-center">
            <RecordsNotFound
                icon="icon-error-outline"
                header="Order Not Found"
                message="Please contact support through live chat if the problem persists."
            />
        </div>
        <div v-else class="absolute inset-0 flex items-center justify-center">
            <LoadingSpinner :large="true" />
        </div>
    </div>
</template>

<script setup>
import {
    DialogCloseButton,
    LoadingSpinner,
    OrderRecord,
    RecordHeader,
    AppButton,
    RecordsNotFound,
} from "@/Components";
import {router} from "@inertiajs/vue3";
import {useUser, useScroll, useStatus} from "@/Composables";
import { watch, computed } from 'vue';

const { scrollClasses, handleScroll } = useScroll();
const { getStatusColors } = useStatus();

let backgroundColorSourcing = computed(() => getStatusColors(props.order?.status));

const props = defineProps([
    "isLoading",
    "order",
    "data",
    "shipmentColumns",
    "lineColumns",
    "invoiceColumns",
    "lineRows",
    "shipmentRows",
    "invoiceRows",
    "errors",
    "cards",
    "salesData",
]);

// Watch for changes in loading state and order
watch([() => props.isLoading, () => props.order], ([isLoading, order]) => {
    if (!isLoading) {
        if (!order) {
            console.log('Order not found or loading failed.');
        } else {
            console.log('Order loaded:', {
                id: order?.id,
                isProxy: order?.__v_isProxy,
                raw: order?.__v_raw || order
            });
        }
    }
}, { immediate: true });
</script>
